import React, { Fragment, memo, useMemo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikCheckboxSelect } from 'src/components/shared/form/formik/FormikCheckboxSelect'
import { FormikSelect } from 'src/components/shared/form/formik/FormikSelect'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import {
  webhookEventGroups,
  webhookEventLabels,
  webhookVersionOptions,
} from 'src/constants/webhook/constants'
import type { WebhookSubscriptionFormValues } from './WebhookSubscriptionForm.interface'

const WebhookSubscriptionFormContentComponent = () => {
  // One checkbox group per resource, so twelve events read as three short lists rather than one
  // long one. Built once — the groups are a module constant.
  const eventGroupOptions = useMemo(() => {
    return webhookEventGroups.map((group) => {
      return {
        label: group.label,
        options: group.events.map((eventType) => {
          return { label: webhookEventLabels[eventType], value: eventType }
        }),
      }
    })
  }, [])

  return (
    <Fragment>
      <FormikTextField<WebhookSubscriptionFormValues>
        name="callbackUrl"
        label="Callback URL"
        placeholder="https://api.example.com/webhooks/gigsafe"
        data-testid="webhook-subscription-callback-url-input"
      />
      <div css={tw`mt-6`}>
        {/* A section heading over three labelled groups: black h6 here, grey h6 (the input-label
            style) on each group inside `BasicCheckboxSelect`. */}
        <Typography variant="h6" css={tw`text-shades-1000`}>
          Events to send
        </Typography>
        <Typography variant="body2" css={tw`mb-4 text-shades-500`}>
          GigSafe posts to the callback URL whenever one of these happens.
        </Typography>
        {eventGroupOptions.map((group) => {
          return (
            <div key={group.label} css={tw`mb-6`}>
              <FormikCheckboxSelect<WebhookSubscriptionFormValues>
                name="events"
                label={group.label}
                options={group.options}
                dataTestId={`webhook-subscription-events-${group.label}`}
              />
            </div>
          )
        })}
      </div>
      <div>
        <FormikSelect<WebhookSubscriptionFormValues>
          name="webhookVersion"
          label="Payload version"
          options={webhookVersionOptions}
          data-testid="webhook-subscription-version-select"
        />
      </div>
    </Fragment>
  )
}

export const WebhookSubscriptionFormContent = memo(WebhookSubscriptionFormContentComponent)
